import {Control, Controller, FieldValues, Path} from 'react-hook-form';
import {FormHelperText} from '@mui/material';
import {DateTimePicker} from '@mui/x-date-pickers';
import {renderMultiSectionDigitalClockTimeView} from '@mui/x-date-pickers/timeViewRenderers';

type Props<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label: string;
  control?: Control<TFieldValues>;
  digitalClock?: boolean;
};

export const RhfDateTimePicker = <TFormValues extends FieldValues>({
  name,
  label,
  control,
  digitalClock,
}: Props<TFormValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({field: {ref: _, ...field}, fieldState}) => (
        <>
          <DateTimePicker
            {...field}
            label={label}
            format="dd.MM.yyyy HH:mm"
            ampm={false}
            {...(digitalClock && {
              viewRenderers: {
                hours: renderMultiSectionDigitalClockTimeView,
                minutes: renderMultiSectionDigitalClockTimeView,
              },
            })}
            slotProps={{
              textField: {
                error: fieldState.invalid,
                size: 'small',
                fullWidth: true,
              },
              // The global `* { padding: 0 }` reset (src/app/GlobalStyles.tsx)
              // wipes out MUI X's own built-in spacing for these sub-parts of
              // the picker popup, since they rely on padding (not gap) for
              // layout.
              toolbar: {
                sx: {padding: '16px 24px'},
              },
              tabs: {
                sx: {padding: '0 12px'},
              },
              actionBar: {
                sx: {padding: '8px 24px 16px'},
              },
            }}
          />
          {fieldState.invalid && (
            <FormHelperText error sx={{mt: 0.5}}>
              {fieldState.error?.message}
            </FormHelperText>
          )}
        </>
      )}
    />
  );
};
